// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agents/models" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsModels } from "./constants";
import type { GenerativeAiAgentsModelsResult, GetGenerativeAiAgentsModelsParams } from "./types";
import { isGenerativeAiAgentsModelsResult } from "./validators";

export const getGenerativeAiAgentsModels = reactQueryFetcherAdapter(
  generativeAiAgentsModels,
  (signal: AbortSignal, params: GetGenerativeAiAgentsModelsParams): Promise<GenerativeAiAgentsModelsResult> =>
    fetch("/generative_ai/agents/models", "GET", params, { signal }),
  isGenerativeAiAgentsModelsResult
);
